import styled from "styled-components";
import { hw } from "../homeworkUi";

interface MenuBarProps{
    menuList?:{
        icon:string,
        name:string,
        id:number
    }[],
    onMenuItemClickHandler:(id:number) => void,
    selectedMenu?:number
}

const MenuBar = ({menuList, onMenuItemClickHandler, selectedMenu}:MenuBarProps) => {
    return(
        <Container>
            {menuList?.map((item) => (
                <IconWrap
                    key={item.id}
                    type="button"
                    $active={item.id === selectedMenu}
                    onClick={() => onMenuItemClickHandler(item.id)}
                >
                    <Icon src={item.icon} alt="" />
                    <Name>{item.name}</Name>
                </IconWrap>
            ))}
        </Container>
    )
}

const Container = styled.nav`
    flex-shrink: 0;
    align-self: stretch;
    width: 92px;
    padding: 12px 8px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    background: ${hw.nav};
    border-right: 1px solid rgba(255, 255, 255, 0.06);
`;

const IconWrap = styled.button<{ $active: boolean }>`
    appearance: none;
    border: none;
    width: 100%;
    padding: 12px 6px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    cursor: pointer;
    border-radius: 10px;
    background: ${props => props.$active ? hw.brand : "transparent"};
    color: ${props => props.$active ? "#FFFFFF" : "#CBD5E1"};
    box-shadow: ${props => props.$active ? "0 6px 16px rgba(223, 0, 0, 0.35)" : "none"};
    transition: background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;

    &:hover {
        background: ${props => props.$active ? hw.brand : hw.navHover};
        color: #FFFFFF;
    }
`;

const Icon = styled.img`
    width: 22px;
    height: 22px;
`;

const Name = styled.span`
    font-size: 12px;
    font-weight: 600;
    line-height: 1.3;
    text-align: center;
    letter-spacing: -0.02em;
`;

export default MenuBar;
